module.exports = __webpack_public_path__ + "img/carousel-productos-4.10b198d3.jpg";